// This file purposefully references translation keys that are only used dynamically
// (for example inside objects) so static extraction tools (i18n CLI / scanners)
// detect them as used and do not remove them from the translation files.
// Import this file from your i18n init (src/i18n.ts) so that the keys are present
// during extraction/bundling. The calls below are no-ops at runtime (they simply
// return the translation string) but ensure the extractor sees the keys as used.

import i18n from "i18next";

// List keys that are referenced dynamically in the codebase.
// Add more keys here whenever you add a dynamic reference.
void i18n.t("common:home");
void i18n.t("common:completed");
void i18n.t("common:created");
void i18n.t("common:statistics");
void i18n.t("contracts:contracts");
void i18n.t("contracts:toAddress");
void i18n.t("contracts:fromAddress");
void i18n.t("common:tasks");
void i18n.t("common:orders");
void i18n.t("common:archive");
void i18n.t("common:size");
void i18n.t("common:archivedDocuments");
void i18n.t("dashboard:reports");
void i18n.t("commonAdmin:adminClaims");
void i18n.t("commonAdmin:adminReports");
void i18n.t("staleTransactions:staleTransactions");
void i18n.t("commonComponents:sortByX");
void i18n.t("commonComponents:filterByX");
void i18n.t("registerCompany:companyInformationControlLabel");
void i18n.t("registerCompany:economyAndLogisticsControlLabel");
void i18n.t("registerCompany:settingsControlLabel");
void i18n.t("registerCompany:teamControlLabel");
void i18n.t("registerCompany:termsAndConditionsControlLabel");
void i18n.t("commonComponents:statusX");
void i18n.t("settings:navigation.transportDevices");
void i18n.t("settings:navigation.receivingInspection");
void i18n.t("orders:locationPermissionDenied");
void i18n.t("orders:locationUnavailable");
void i18n.t("orders:locationTimeout");

// Export nothing; this file only exists to keep translation keys alive for static extraction.
export {};
